import { render } from "./ShortCoursesFilterContainer.vue?vue&type=template&id=b50e4050&ts=true"
import script from "./ShortCoursesFilterContainer.ts?vue&type=script&lang=ts&external"
export * from "./ShortCoursesFilterContainer.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__